import React from "react"
import { BsTrash } from "react-icons/bs"
import { type Props } from "./_types"
const IconTrash: React.FC<Props> = ({ size = 15, color = "#fff", onclick }): React.ReactElement => {
  return <BsTrash size={size} style={{ cursor: "pointer" }} color={color} onClick={onclick} />
}

export default IconTrash
